<cdx-slotted-modal
	*ngIf="priceChangeDetails?.requestedItemOldSellPrice && priceChangeDetails?.requestedItemNewSellPrice"
	size="medium"
	center="true"
	class="changed-price-modal"
	[canDismiss]="true"
	[applyBasicModalFooterStyle]="true"
    (close)="handleCancelEdits(actionOnPriceChange.close)"
>
	<h1 modal-header i18n="@@changedPrice-heading" class="changedPriceHeader">Item price has changed</h1>
	<div modal-content>
        <div class="changedPriceInfo">
            <span class="was">
                <h2>Was</h2>
				<h2> {{ getFormattedPrice(priceChangeDetails.requestedItemOldSellPrice) }} </h2>
            </span>
            <span class="divider"></span>
            <span class="now">
                <h2>Now</h2>
				<h2> {{ getFormattedPrice(priceChangeDetails.requestedItemNewSellPrice) }} </h2>
            </span>
        </div>
        <div class="changedPriceMessage">
            <p i18n="@@changedPrice-infoMessagePrimary">
                Why? Prices can fluctuate due to things like seasonal availability and temporary promotions. 
                Edited items will be at today's price. If you want to keep the original price, cancel the changes to the order. 
            </p>
        </div>
	</div>
	<button
		*ngIf="showActionButtons" 
		id="changedPriceCancelEdits"
		cdxButton
		modal-footer-secondary
		autofocus
        fillStyle="outline"
		i18n="@@changedPrice-cancelEditsButton"
		size="large"
		(click)="handleCancelEdits(actionOnPriceChange.cancel)"
	>
		Cancel edits
	</button>
	<button
		*ngIf="showActionButtons"
		id="changedPriceAccept"
		cdxButton
		modal-footer-primary
		autofocus
        fillStyle="primary"
		i18n="@@changedPrice-acceptButton"
		size="large"
		(click)="handleAcceptEdits()"
	>
		Accept
	</button>
</cdx-slotted-modal>
